import type { Optional } from '@festina-life/core'
import { createContext, useContext } from 'react'

import type { EventSelectionWithApplyDate } from '../../../../components/commitmentEvents/commitmentEventSelectionContext'

type CompanyLegalentityEventSelectionContext = {
  current: Optional<EventSelectionWithApplyDate>
  previous: Optional<EventSelectionWithApplyDate>
  setCurrent: (event: Optional<EventSelectionWithApplyDate>) => void
  setPrevious: (event: Optional<EventSelectionWithApplyDate>) => void
}

const CompanyLegalentityEventSelectionContext =
  createContext<CompanyLegalentityEventSelectionContext | null>(null)

const useCompanyLegalentityEventSelectionContext = () => {
  const context = useContext(CompanyLegalentityEventSelectionContext)

  if (!context) {
    throw new Error(
      'You must wrap your app in a CompanyLegalentityEventSelectionProvider to use the CompanyLegalentityEventSelectionContext',
    )
  }

  return context
}

const Provider = CompanyLegalentityEventSelectionContext.Provider

export { Provider, useCompanyLegalentityEventSelectionContext }
